<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Cadastrar Pergunta</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <b-form-group label="Exibir para o(s) perfil(is): *">
                  <b-form-select
                    multiple
                    :select-size="3"
                    v-model="$v.form.perfil.$model"
                    :state="chkState('perfil')"
                  >
                    <option
                      v-for="item in listacombo"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.nome }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback
                    :state="chkState('perfil')"
                    id="input1LiveFeedback1"
                    >Perfil é obrigatório.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Pergunta: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Pergunta"
                    v-model="$v.form.pergunta.$model"
                    :state="chkState('pergunta')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1"
                    >Pergunta é obrigatória.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Resposta: *">
                <b-input-group class="mb-6">
                  <b-form-textarea
                    class="form-control"
                    placeholder="Descreva a resposta"
                    v-model="$v.form.resposta.$model"
                    :state="chkState('resposta')"
                    rows="3"
                    max-rows="6"
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback1"
                    >Resposta é obrigatória.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4">
              <b-form-group label="Ativo: *">
                <b-input-group class="mb-6">
                  <b-form-select
                    v-model="$v.form.ativo.$model"
                    :state="chkState('ativo')"
                  >
                    <option selected :value="null">Selecione</option>
                    <option selected :value="true">Sim</option>
                    <option selected :value="false">Não</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback6"
                    >Ativação é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group label="Ordem de Exibição: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    min="1"
                    placeholder="Ordem de exibição"
                    v-model="$v.form.ordem_exibicao.$model"
                    :state="chkState('ordem_exibicao')"
                    autofocus
                  />
                  <b-form-invalid-feedback v-if="!$v.form.ordem_exibicao.required"
                    >Ordem de exibição é obrigatório.</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback v-if="!$v.form.ordem_exibicao.orderLimit"
                    >Ordem de exibição não pode ser maior que a ordem limite disponível.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group label="Ordem limite disponível:">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    v-model="ordemLimite"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Link: *">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-link"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Link do faq"
                    v-model="$v.form.link.$model"
                    :state="chkState('link')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback4"
                    >Link é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3" offset-md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span
                >Voltar</span
              >
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'
import ListDepoimentosVue from '../depoimentos/ListDepoimentos.vue'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  pergunta: '',
  resposta: '',
  perfil: null,
  ordem_exibicao: '',
  ativo: null,
  link: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      pergunta: {
        required
      },
      resposta: {
        required
      },
      perfil: {
        required
      },
      ordem_exibicao: {
        required,
        orderLimit: function (value) {
          return value <= this.ordemLimite
        }
      },
      ativo: {
        required
      },
      link: {
        required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/faqs/list')
    }
  },
  watch: {
    '$v.form.ordem_exibicao.$model': function () {
      if (this.$v.form.ordem_exibicao.$model) {
        this.$v.form.ordem_exibicao.$model = this.$v.form.ordem_exibicao.$model == 0 ? 1 : Number(this.$v.form.ordem_exibicao.$model.replace('-', ''))
      }
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: null,
      reorder: false,
      ordemLimite: null,
      listacombo: [
        {
          id: 1,
          nome: 'Público Geral'
        },
        {
          id: 2,
          nome: 'Voluntária'
        },
        {
          id: 3,
          nome: 'Beneficiária'
        }
      ],
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      }
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.load(this.$route.params.id)
      this.ultimaOrdem(true)
    } else {
      this.ultimaOrdem(false)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        resposta: form.resposta.$model,
        pergunta: form.pergunta.$model,
        perfil: form.perfil.$model,
        ordem_exibicao: form.ordem_exibicao.$model,
        ativo: form.ativo.$model,
        link: form.link.$model,
        reorder: this.reorder
      }

      Vue.http
        .post('api/faqs', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            if (this.cadastroInterno) {
              miniToastr.success('Pergunta salva com sucesso!', 'Sucesso!', 7000)
            } else {
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            }

            this.$router.push({ path: '/faqs' })
          } else {
            if (response.body.data['valida_reorder']) {
              this.$bvModal
                .msgBoxConfirm(response.body.msg, {
                  okTitle: 'Confirmar',
                  cancelTitle: 'Cancelar'
                })
                .then((valor) => {
                  if (valor) {
                    this.reorder = true
                    this.salvar()
                  }
                })
            } else {
              this.disable_buttons = false
              miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
          }
        })
        .catch((e) => {
          console.log('Servidor está fora! ' + e)
        })
    },
    load (id) {
      Vue.http.get('api/faqs/' + id).then((response) => {
        this.form.pergunta = response.body.data[0].pergunta
        this.form.resposta = response.body.data[0].resposta
        this.form.perfil = response.body.data[0].perfil
        this.form.ordem_exibicao = response.body.data[0].ordem_exibicao
        this.form.ativo = response.body.data[0].ativo
        this.form.link = response.body.data[0].link
        this.id = response.body.data[0].id
      })
    },
    ultimaOrdem (edit) {
      Vue.http.get('api/faqs/ordem/ultimo').then((response) => {
        let limit = Number(response.body.data['ordem']) + 1
        this.ordemLimite = limit
        if (!edit) {
          this.form.ordem_exibicao = limit
        }
      })
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/faq/FaqForm.vue